<!-- eslint-disable vue/no-mutating-props -->
<template>
  <el-dialog
    v-model="show"
    width="900"
    :fullscreen="$vuetify.display.width <= 600 ? true : false"
    class="public-style"
    destroy-on-close
    align-center
    @close="close"
  >
    <el-form
      ref="ruleFormRef"
      :model="logData"
      :style="[$vuetify.display.width < 600 ? 'height: 550;' : '']"
      :label-position="`top`"
    >
      <el-space fill style="width: 100%">
        <!-- Log Information Section -->
        <el-alert type="info" class="alert-style" show-icon :closable="false">
          <p class="ma-0 text-white">Session Reallocation Log</p>
        </el-alert>
        
        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="user_full_name" label="User Full Name:">
              <el-input v-model="logData.user_full_name" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="user_email" label="User Email:">
              <el-input v-model="logData.user_email" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="form_kind" label="Form Kind:">
              <el-input v-model="logData.form_kind" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="action_kind" label="Action Kind:">
              <el-input v-model="logData.action_kind" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="document_id" label="Document ID:">
              <el-input v-model="logData.document_id" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="log_date" label="Log Date:">
              <el-input :value="formatDateTime(logData.log_date)" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="created_at" label="Created At:">
              <el-input :value="formatDateTime(logData.created_at)" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- Reallocation Details Section -->
        <el-alert type="warning" class="alert-style" show-icon :closable="false">
          <p class="ma-0 text-white">Reallocation Details</p>
        </el-alert>

        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="register_id" label="Register ID:">
              <el-input v-model="reallocationData.register_id" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 6 : 24">
            <el-form-item class="label-style" prop="customer_id" label="Customer ID:">
              <el-input :value="reallocationData.customer_id" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 6 : 24">
            <el-form-item class="label-style" prop="user_id" label="User ID:">
              <el-input :value="reallocationData.user_id" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- Session Counts Section -->
        <el-alert type="success" class="alert-style" show-icon :closable="false">
          <p class="ma-0 text-white">Session Counts Summary</p>
        </el-alert>

        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="pending_count" label="Pending Count:">
              <el-tag type="warning" size="large">
                {{ reallocationData.pending_count || '0' }}
              </el-tag>
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="success_count" label="Success Count:">
              <el-tag type="success" size="large">
                {{ reallocationData.success_count || '0' }}
              </el-tag>
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="invalid_count" label="Invalid Count:">
              <el-tag type="danger" size="large">
                {{ reallocationData.invalid_count || '0' }}
              </el-tag>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="pending_sum_kwh" label="Pending Sum (kWh):">
              <el-input :value="formatKwh(reallocationData.pending_sum_kwh)" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="success_sum_kwh" label="Success Sum (kWh):">
              <el-input :value="formatKwh(reallocationData.success_sum_kwh)" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="invalid_sum_kwh" label="Invalid Sum (kWh):">
              <el-input :value="formatKwh(reallocationData.invalid_sum_kwh)" readonly />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item class="label-style" prop="duplicate_deleted_count" label="Duplicate Deleted Count:">
              <el-tag type="info" size="large">
                {{ reallocationData.duplicate_deleted_count || '0' }}
              </el-tag>
            </el-form-item>
          </el-col>
        </el-row>

      </el-space>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button
          size="medium"
          class="me-primary"
          @click.stop="close"
          color="#ddf0ac"
        >
          <i class="fa fa-times me-2 me-primary"></i>
          <span class="moderat-btn-apply">Close</span>
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
export default {
  props: {
    open_modal: {
      type: Boolean,
      default: false,
    },
    data_modal: {
      type: Object,
      // eslint-disable-next-line no-unused-vars
      default(rawProps) {
        return {};
      },
    },
  },
  data() {
    return {
      show: this.open_modal,
      logData: {
        id: 0,
        log_date: "",
        form_kind: "",
        action_kind: "",
        document_id: "",
        comment: "",
        user_id: 0,
        user_full_name: "",
        user_email: "",
        created_at: "",
        updated_at: "",
        before_change: "",
      },
      reallocationData: {
        register_id: "",
        customer_id: null,
        user_id: null,
        comment: "",
        pending_count: "0",
        pending_sum_kwh: null,
        success_count: "0",
        success_sum_kwh: null,
        invalid_count: "0",
        invalid_sum_kwh: null,
        duplicate_deleted_count: "0",
      },
    };
  },
  computed: {
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    open_modal: function (newVal, oldVal) {
      this.show = newVal;
      if (newVal === true) {
        this.parseModalData();
      }
    },
  },
  methods: {
    parseModalData() {
      if (this.data_modal) {
        // Handle both string and object input
        const data = typeof this.data_modal === 'string' 
          ? JSON.parse(this.data_modal) 
          : this.data_modal;
        
        this.logData = { ...data };
        
        // Parse the before_change JSON string for reallocation details
        if (data.before_change) {
          try {
            this.reallocationData = typeof data.before_change === 'string'
              ? JSON.parse(data.before_change)
              : data.before_change;
          } catch (e) {
            console.error("Error parsing before_change:", e);
            this.reallocationData = {
              register_id: "",
              customer_id: null,
              user_id: null,
              comment: "Error parsing reallocation data",
              pending_count: "0",
              pending_sum_kwh: null,
              success_count: "0",
              success_sum_kwh: null,
              invalid_count: "0",
              invalid_sum_kwh: null,
              duplicate_deleted_count: "0",
            };
          }
        }
      }
    },
    formatDateTime(dateStr) {
      if (!dateStr) return "";
      try {
        const date = new Date(dateStr);
        return date.toLocaleString("en-AU", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        });
      } catch (e) {
        return dateStr;
      }
    },
    formatKwh(value) {
      if (value === null || value === undefined || value === "") return "N/A";
      const num = parseFloat(value);
      if (isNaN(num)) return "N/A";
      return num.toFixed(2) + " kWh";
    },
    close() {
      this.show = false;
      this.$emit("close_modal", false);
    },
  },
};
</script>

<style scoped>
.el-dialog__body {
  padding: 30px 10px;
}

.el-input__inner {
  padding: 0 10px !important;
}

::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.el-form-item__label {
  margin-bottom: 0 !important;
}

.el-form-item__content > .el-checkbox {
  margin-top: 16px;
  margin-bottom: 0;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.mt-3 {
  margin-top: 12px;
}

.alert-style {
  margin-bottom: 10px;
}

</style>
